import React, { useContext, useEffect, useState } from "react";
import { useCartContext } from "../../context/CartContext";
import CartClass from "../../classes/CartClass";
import RequestClass from "../../classes/RequestClass";
import { BASKET_TYPE_CHOICES } from "../../components/Enumerators";
import CartItem from "./CartItem";
import { ICartProduct } from "../../interfaces/ICartProduct";
import { UserContext } from "../../context/UserContext";
// import { ICartProduct } from '../../interfaces/ICartProduct';

const CartItemsSummary = (props: any) => {
    const { setActiveStepId, basketId, order, setOrder } = useCartContext();
    const [isLoaded, setIsLoaded] = useState(false);
    const [notification, setNotification] = useState<JSX.Element | String>();
    const { setBasketCnt } = useContext(UserContext);

    // console.log(isLoaded);
    /* -----
     *  wysłanie zapytania o koszyk -> przy zmianie basketId
     * ----- */
    useEffect(() => {
        function succ_callback(result: any) {
            // console.log("zawartosc koszyka");
            // if ()result["type"]== -1
            // console.log(result["type"]);
            if (result !== null) {
                var prodCnt = 0;
                if (order !== undefined) {
                    if (setOrder && result.products !== undefined) {
                        setOrder({ ...order, products: result.products });
                        prodCnt = result.products.length;
                    }
                }
                setBasketCnt(prodCnt);
            }
            setIsLoaded(true);
        }

        function err_callback(result: any) {
            setNotification(RequestClass.errorAlert(result));
        }

        // wysłanie zapytanie do serwera
        CartClass.get(BASKET_TYPE_CHOICES.BASKET_ORDER, succ_callback, err_callback);
    }, [basketId]);

    /* -----
     *  przeliczenie sumy zamówienia
     * ----- */
    useEffect(() => {
        let suma = 0;
        if (order?.products) {
            //console.log(order.products)
            Object.values(order.products).forEach((element: ICartProduct) => {
                if (element.product?.price !== undefined && element.cnt !== undefined) suma += element.cnt * element.product.price;
            });
            if (setOrder) setOrder({ ...order, summary: suma });
            //setSummary(suma)
        }
    }, [order?.products]);

    /* -----
     *  przejdź Dalej
     * ----- */
    function onSubmitNext() {
        /* tu jest miejsce na dodatkowa logikę, jeżeli będzie potrzebna */

        if (setActiveStepId) setActiveStepId(2);
    }

    if (!isLoaded) {
        return (
            <div>
                Pobieranie zawartości koszyka...
                {notification}
            </div>
        );
    } else {
        return (
            <>
                {notification}
                <div id="cart-summary" className={"tab cart-step active"}>
                    <div id="cart" className="block">
                        {order?.products?.map((cartProduct, index: number) => (
                            <>
                                <CartItem key={cartProduct.product?.productId} cartProduct={cartProduct} />
                                {order?.products && order?.products?.length > index + 1 && (
                                    <>
                                        <hr className="mb-0 mt-4"></hr>
                                    </>
                                )}
                            </>
                        ))}
                    </div>

                    <div id="webinar-summary" className="block">
                        {/* <div className="discount-info">
                    Po&nbsp;zapisaniu się, otrzymasz kod rabatowy na&nbsp;kolejne szkolenie!
                </div> */}

                        {/* <div>
                    <label>Kod rabatowy</label>
                    <input id="promo-code" name="promo_code" type="text" className="input ml-3" />
                    <p id="use-promo">Zastosuj</p>
                </div> */}

                        {/* <div className="discount-calculations is-hidden">
                    <label>Rabat</label>
                    <div id="promo-value" className="input-box" ></div>
                    <input type="hidden" name="discount_fixed"/>
                    <input type="hidden" name="discount_percent" />
                    <input type="hidden" name="permanent_code" value="0" />
                </div> */}

                        <div>
                            <label>Całkowity koszt szkoleń</label>
                            <input id="summary" className="ml-3 input" type="text" name="summary" value={order?.summary} readOnly /> zł
                        </div>

                        {/* <div className="discount-calculations is-hidden">
                    <label>Koszt po&nbsp;rabacie</label>
                    <div id="cost-after-promo" className="input-box" >0 zł</div>
                    <input type="hidden" name="cost_after_promo_input" value="0" />
                </div> */}
                    </div>

                    <div className="has-text-centered">
                        <div className="button is-primary next-step" data-step="2" onClick={onSubmitNext}>
                            Przejdź dalej <i className="ml-2 fas fa-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default CartItemsSummary;
